import axios from "axios"


const CustomerService = {

    login(email: string, password: string) {
        return axios.post<CustomerAPILoginResponse>('/customer/v1/users/login', {
            email: email,
            password: password
        });
    },

    logout() {
        return axios.post('/customer/v1/users/logout', {});
    },

    forgotPassword(email: string) {
        return axios.post('/customer/v1/users/forgot-password', {
            email: email
        })
    },

    getMe() {
        return axios.get<APICustomerUserPrincipal>('/customer/v1/users/me')
    },

    searchCustomerDeliveries() {
        return axios.get(`/customer/v1/consignments`);
    }

};

export default CustomerService;
